import React, { useState } from "react";
import { Box, Typography, Link, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import Logo from "../../Assets/Images/logo.png";
import { theme } from "../../Assets/Theme/theme";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";

function Footer() {
  const navigate = useNavigate();
  const [toastShown, setToastShown] = useState(false);

  const handleNavigation = async (country, currencySymbol) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/search/country/experience`,
        { country, currencysymbol: currencySymbol }
      );

      if (response?.data?.data?.length > 0) {
        navigate("/experience", {
          state: { country, data: response?.data?.data },
        });
      } else {
        if (!toastShown) {
          toast.info(`No experiences available for ${country}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setToastShown(true);
          setTimeout(() => {
            setToastShown(false);
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error fetching experiences:", error);
      if (!toastShown) {
        toast.error("Failed to fetch experiences. Please try again later.", {
          position: "top-right",
        });
        setToastShown(true);
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: { 
            xs: "16px 12px", 
            sm: "20px 16px", 
            md: "32px 24px", 
            lg: "48px 32px" 
          },
          borderTop: "1px solid #ddd",
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "center", lg: "flex-start" },
          textAlign: { xs: "center", lg: "left" },
          gap: { xs: 3, sm: 4, md: 5, lg: 0 },
        }}
      >
        {/* Logo Section */}
        <Box 
          onClick={() => navigate("/")} 
          sx={{ 
            cursor: "pointer",
            order: { xs: 1, lg: 1 },
            flexShrink: 0,
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              width: "clamp(50px, 8vw, 69px)",
              height: "clamp(58px, 9.5vw, 80px)",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Navigation Links Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 3, sm: 4, md: 6, lg: 8 },
            order: { xs: 2, lg: 2 },
            justifyContent: { xs: "center", lg: "space-evenly" },
            alignItems: { xs: "center", sm: "flex-start" },
            flex: { lg: 1 },
            maxWidth: { xs: "100%", lg: "65%" },
            width: "100%",
          }}
        >
          {/* Main Navigation */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.5, sm: 1, md: 1.5 },
              textAlign: 'center',
              minWidth: { sm: "120px", md: "140px" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => navigate("/")}
            >
              Home
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => navigate("/experience")}
            >
              Experience
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </Typography>
          </Box>

          {/* Country Navigation */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.5, sm: 1, md: 1.5 },
              textAlign: 'center',
              minWidth: { sm: "160px", md: "180px", lg: "200px" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => handleNavigation("United Arab Emirates", "$")}
            >
              Things to do in UAE
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => handleNavigation("United States", "$")}
            >
              Things to do in USA
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
                color: theme.colors.text,
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                "&:hover": {
                  textDecoration: "underline"
                },
                transition: "all 0.2s ease-in-out",
                lineHeight: 1.3,
              }}
              onClick={() => handleNavigation("Canada", "$")}
            >
              Things to do in UK
            </Typography>
          </Box>

          {/* Legal Links */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.5, sm: 1, md: 1.5 },
              textAlign: 'center',
              minWidth: { sm: "140px", md: "160px" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography
              variant="body2"
              sx={{ 
                fontWeight: "bold", 
                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                lineHeight: 1.3
              }}
            >
              <Link 
                href="/terms-conditions" 
                underline="hover" 
                color="#121212"
                sx={{
                  transition: "all 0.2s ease-in-out",
                }}
              >
                Terms and conditions
              </Link>
            </Typography>
            <Typography
              variant="body2"
              sx={{ 
                fontWeight: "bold", 
                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                color: "#121212",
                lineHeight: 1.3
              }}
            >
              <Link 
                href="/refund-policy" 
                underline="hover" 
                color="#121212"
                sx={{
                  transition: "all 0.2s ease-in-out",
                }}
              >
                Refund Policy
              </Link>
            </Typography>
          </Box>
        </Box>

        {/* Social Media Section */}
        <Box 
          sx={{ 
            textAlign: "center",
            order: { xs: 3, lg: 3 },
            flexShrink: 0,
            width: { xs: "100%", lg: "auto" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              marginBottom: { xs: 2, sm: 1.5, md: 1 },
              color: "#121212",
              fontSize: { xs: "18px", sm: "20px", md: "22px", lg: "24px" },
            }}
          >
            Connect With Us
          </Typography>
          <Box 
            sx={{ 
              display: "flex", 
              justifyContent: "center", 
              gap: { xs: 1.5, sm: 1, md: 1 },
              flexWrap: "wrap",
            }}
          >
            <Link
              href="https://www.facebook.com/thedestinationmaster/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  width: { xs: "32px", sm: "36px", md: "40px" },
                  height: { xs: "32px", sm: "36px", md: "40px" },
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#1877F2",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <IconButton 
                  sx={{ 
                    color: "#fff",
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    padding: 0,
                  }}
                >
                  f
                </IconButton>
              </Box>
            </Link>

            <Link
              href="https://www.instagram.com/thedestinationmaster/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  width: { xs: "32px", sm: "36px", md: "40px" },
                  height: { xs: "32px", sm: "36px", md: "40px" },
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #833AB4, #E1306C, #F77737, #FCAF45)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <IconButton sx={{ color: "#fff", padding: 0 }}>
                  <InstagramIcon sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }} />
                </IconButton>
              </Box>
            </Link>

            <Link
              href="https://www.twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  width: { xs: "32px", sm: "36px", md: "40px" },
                  height: { xs: "32px", sm: "36px", md: "40px" },
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#1DA1F2",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <IconButton sx={{ color: "#fff", padding: 0 }}>
                  <TwitterIcon sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }} />
                </IconButton>
              </Box>
            </Link>
          </Box>
        </Box>
      </Box>

      {/* Copyright Section */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          borderTop: "1px solid #ddd",
          paddingY: { xs: 2, sm: 2.5, md: 3 },
          backgroundColor: "#f9f9f9",
        }}
      >
        <Typography 
          variant="caption" 
          sx={{
            color: "text.secondary",
            fontSize: { xs: "12px", sm: "13px", md: "14px" },
            display: "block",
          }}
        >
          Destination Master All rights reserved.
        </Typography>
      </Box>
    </>
  );
}

export default Footer;